import WholeMilkProduct from 'models/WholeMilkProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WholeMilkPackage from './WholeMilkPackage'

const productOptions = {
  packagingInfo: <WholeMilkPackage />,
  productTitle: 'Whole Milk',
  model: WholeMilkProduct,
  validCategories: ['51'],
  validSubCategories: ['001', '003', '011'],
}

const WholeMilk = () => <ProductForm product={productOptions} />

export default WholeMilk

export const getWholeMilkPackage = newProduct => {
  const newWholeMilkPackage = {
    UPC: newProduct.UPC,
    MilkType: 'Whole Milk',
    WholeMilkType: newProduct.WholeMilkType,
    WholeMilkSize: newProduct.WholeMilkSize,
  }
  return newWholeMilkPackage
}
export const updateWholeMilkPackage = newProduct => {
  const newWholeMilkPackage = {
    UPC: newProduct.UPC,
    MilkType: 'Whole Milk',
    WholeMilkType: newProduct.WholeMilkType,
    WholeMilkSize: newProduct.WholeMilkSize,
  }
  return newWholeMilkPackage
}
